<template>
  <div class="form-container">
      <button style="border:1px solid red;position: absolute;right: 0; width: 200px;height: 200px;opacity: 0;z-index: 1" @click="restart">
          restart
      </button>
      <button style="border:1px solid red;position: absolute;left: 0; width: 200px;height: 200px;opacity: 0;z-index: 1" @click="clickF11">
          f11
      </button>
    <!-- 步骤指示器 -->
<!--    <div class="step-indicator">
      <div 
        v-for="(step, index) in steps" 
        :key="index" 
        class="step-dot"
        :class="{ active: currentStep === index, completed: currentStep > index }"
      >
        <span v-if="currentStep > index">✓</span>
        <span v-else>{{ index + 1 }}</span>
      </div>
    </div>-->

    <!-- 步骤内容 -->
    <div class="step-content" :class="{ 'dialog-step': currentStep === 5 }">
      <!-- 第0步：触摸进入页面 -->
      <div v-if="currentStep === 0" class="step0-welcome" @click="enterForm">
        <div class="welcome-content">
          <h1 class="welcome-title">欢迎来到AI时尚助手</h1>
          <p class="welcome-subtitle">点击屏幕开始您的时尚之旅</p>
          <div class="welcome-tap-hint">
            <div class="tap-icon">👆</div>
            <span>触摸进入</span>
          </div>
        </div>
      </div>
<!--
      &lt;!&ndash; 第一步：个人信息表单 &ndash;&gt;
      <PersonalInfoStep1Content 
        v-if="currentStep === 1"
        ref="step1Ref"
        :initialData="formData.step1"
        @next="handleStep1Next"
        @validation-change="handleStep1ValidationChange"
      />-->
      
      <!-- 第二步：身体类型选择 -->
      <PersonalInfoStep2Content 
        v-if="currentStep === 2"
        ref="step2Ref"
        :initialData="formData.step2"
        :allFormData="formData"
        @next="handleStep2Next"
        @back="goBack"
        @validation-change="handleStep2ValidationChange"
      />
      
      <!-- 第三步：图片上传 -->
      <PersonalInfoStep3Content 
        v-if="currentStep === 1"
        ref="step3Ref"
        :step1Data="formData.step1"
        :step2Data="formData.step2"
        :initialData="formData.step3"
        @next="handleStep3Next"
        @validation-change="handleStep3ValidationChange"
        @data-change="handleStep3DataChange"
      />
      <!-- 第五步：对话 -->
      <Dialog 
        v-if="currentStep === 5"
        ref="dialogRef"
        :allFormData="formData"
      />
    </div>


    
    <!-- 第一步的右侧箭头图标（无按钮，仅图标） -->
    <img
      v-if="currentStep === 1"
      class="step1-arrow-img"
      :class="{ disabled: !step1FormValid }"
      :src="step1FormValid ? nextY : nextN"
      alt="next"
      @click="step1FormValid && handleStep1Arrow()"
    />
    
    <!-- 第二步的左右箭头（纯图标） -->
    <!-- 左箭头 - 返回上一步 -->


    
    <!-- 第三步的左右箭头按钮 -->
    <!-- 左箭头 - 返回上一步 -->
    <img 
      v-if="currentStep === 3"
      class="step3-left-arrow-img"
      :src="lastYIcon"
      alt="back"
      @click="goBack"
    />
    
    <!-- 右箭头 - 进入第四步 -->
    <img 
      v-if="currentStep === 3"
      class="step3-right-arrow-img"
      :class="{ disabled: !step3FormValid }"
      :src="step3FormValid ? nextY : nextN"
      alt="next"
      @click="step3FormValid && handleStep3Arrow()"
    />
    
    <!-- 第四步的左箭头按钮（只有返回，没有下一步） -->
    <img 
      v-if="currentStep === 4"
      class="step4-left-arrow-img"
      :src="lastYIcon"
      alt="back"
      @click="goBack"
    />
    
    <!-- 第五步（Dialog）不显示返回按钮 -->
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import PersonalInfoStep2Content from './PersonalInfoStep2Content.vue'
import PersonalInfoStep3Content from './PersonalInfoStep3Content.vue'
import Dialog from '../views/Dialog.vue'
import { safeStorage } from '../utils/incognito'
import { expiredStorage } from '../utils/expiredStorage'
import lastYIcon from '@/assets/images/svg/lastY.svg'
import lastNIcon from '@/assets/images/svg/lastN.svg'
import nextY from '@/assets/images/svg/nextY.svg'
import nextN from '@/assets/images/svg/nextN.svg'

// 可以接收一些通用的配置参数
const props = defineProps({
  width: {
    type: String,
    default: '60%'
  }
})

// 当前步骤
const currentStep = ref(0)

// 步骤配置
const steps = reactive([
  { name: '欢迎页面', component: 'WelcomePage' },
  { name: '个人信息', component: 'PersonalInfoStep1Content' },
  { name: '身体类型', component: 'PersonalInfoStep2Content' },
  { name: '图片上传', component: 'PersonalInfoStep3Content' },
  { name: '品牌选择', component: 'PersonalInfoStep4Content' },
  { name: '对话', component: 'Dialog' }
])

// 存储各步骤的数据
const formData = reactive({
  step1: {},
  step2: {},
  step3: {},
  step4: {}
})

// 进入表单（从欢迎页面到第一步）
const enterForm = () => {
  console.log('进入表单，跳转到第一步')
  currentStep.value = 1
}

// 处理第一步的下一步
const handleStep1Next = (stepData) => {
  formData.step1 = stepData
  console.log('第一步数据:', stepData)
  currentStep.value = 2
}

// 处理第二步的下一步
const handleStep2Next = (stepData) => {
  formData.step2 = stepData
  console.log('第二步数据:', stepData)
  console.log('完整表单数据:', formData)
  currentStep.value = 5
}

// 返回上一步
const goBack = () => {
  if (currentStep.value > 0) {
    currentStep.value--
  }
}

// 处理第一步箭头点击
const handleStep1Arrow = () => {
  // 直接调用第一步的handleSubmit方法
  if (step1Ref.value && typeof step1Ref.value.handleSubmit === 'function') {
    step1Ref.value.handleSubmit()
  } else {
    console.warn('step1Ref.value.handleSubmit is not available')
  }
}

// 第一步组件引用
const step1Ref = ref(null)

// 第一步表单验证状态
const step1FormValid = ref(false)

// 处理第一步验证状态变化

// 第二步组件引用和验证状态
const step2Ref = ref(null)
const step2FormValid = ref(false)

// 处理第二步验证状态变化
const handleStep2ValidationChange = (isValid) => {
  step2FormValid.value = isValid
}

// 处理第二步箭头点击
const handleStep2Arrow = () => {
  if (step2Ref.value && typeof step2Ref.value.handleSubmit === 'function') {
    step2Ref.value.handleSubmit()
  } else {
    console.warn('step2Ref.value.handleSubmit is not available')
  }
}

// 第三步相关
const step3Ref = ref(null)
const step3FormValid = ref(false)

// 处理第三步的下一步
const handleStep3Next = (stepData) => {
  formData.step3 = stepData
  console.log('第三步数据:', stepData)
  
  // 如果有uploadResult，保存到formData中
  if (stepData.uploadResult) {
    formData.uploadResult = stepData.uploadResult
    console.log('API上传结果已保存:', stepData.uploadResult)
  }
  
  currentStep.value = 2
}

// 处理第三步验证状态变化
const handleStep3ValidationChange = (isValid) => {
  step3FormValid.value = isValid
}

// 处理第三步数据变化（实时保存图片数据）
const handleStep3DataChange = (stepData) => {
  console.log('=== FormContainer收到Step3数据变化 ===')
  console.log('接收到的stepData:', stepData)
  console.log('stepData.uploadResult:', stepData.uploadResult)
  
  formData.step3 = { ...formData.step3, ...stepData }
  
  // 如果有uploadResult，保存到formData中
  if (stepData.uploadResult) {
    formData.uploadResult = stepData.uploadResult
    console.log('第三步API上传结果实时保存:', stepData.uploadResult)
    console.log('当前formData.uploadResult:', formData.uploadResult)
  } else {
    console.log('stepData中没有uploadResult字段')
  }
  
  console.log('第三步数据实时保存完成，当前formData:', formData)
  console.log('=== Step3数据变化处理结束 ===')
}

// 处理第三步箭头点击
const handleStep3Arrow = () => {
  if (step3Ref.value && typeof step3Ref.value.handleSubmit === 'function') {
    step3Ref.value.handleSubmit()
  } else {
    console.warn('step3Ref.value.handleSubmit is not available')
  }
}

// 第四步相关
const step4Ref = ref(null)
const isGeneratingAvatar = ref(false) // 防止重复调用头像生成

// 重新开始 - 重置所有状态
const restart = () => {
  console.log('重新开始 - 重置所有状态')
  
  // 重置步骤到初始状态
  currentStep.value = 0
  
  // 清空所有表单数据
  formData.step1 = {}
  formData.step2 = {}
  formData.step3 = {}
  formData.step4 = {}
  if (formData.uploadResult) {
    delete formData.uploadResult
  }
  
  // 清除浏览器存储的数据
  try {
    expiredStorage.removeItem('agent-form-step1')
    expiredStorage.removeItem('agent-form-step2')
    expiredStorage.removeItem('agent-form-step3')
    expiredStorage.removeItem('agent-form-step4')
    safeStorage.removeItem('agent-form-step1')
    safeStorage.removeItem('agent-form-step2')
    safeStorage.removeItem('agent-form-step3')
    safeStorage.removeItem('agent-form-step4')
    safeStorage.removeItem('agent-form-step44')
    safeStorage.removeItem('user')
    console.log('已清除所有浏览器存储数据')
  } catch (error) {
    console.warn('清除浏览器存储失败:', error)
  }
  
  // 重置验证状态
  step1FormValid.value = false
  step2FormValid.value = false
  step3FormValid.value = false
  
  // 重置头像生成状态
  isGeneratingAvatar.value = false
  
  console.log('所有状态已重置，返回欢迎页面')
}
const clickF11 = () => {
    const element = document.documentElement;
    if (!document.fullscreenElement) {
        element.requestFullscreen?.();
    } else {
        document.exitFullscreen?.();
    }
};
// 将 restart 方法暴露给父组件
defineExpose({
  restart
})

// 处理第四步提交（跳转到Dialog并持久化数据到浏览器）
onMounted(async () => {
  try {
    // 预加载下一步图标到缓存
    const preloadImages = [lastYIcon, lastNIcon]
    preloadImages.forEach((src) => {
      const img = new Image()
      img.src = src
    })

    // 检测是否为无痕模式
    const isIncognito = await import('@/utils/incognito').then(module => module.isIncognitoMode())
    if (isIncognito) {
      console.log('无痕模式检测到，清除已保存的数据并重新开始流程')
      // 清除所有相关数据
      safeStorage.removeItem('agent-form-step4')
      safeStorage.removeItem('agent-form-step1')
      safeStorage.removeItem('agent-form-step2')
      safeStorage.removeItem('agent-form-step3')
      // 重置到第一步
      currentStep.value = 0
      // 清空表单数据
      formData.value = {
        step1: {},
        step2: {},
        step3: {},
        step4: {}
      }
      // 显示提示信息
      alert('检测到无痕浏览器模式，已清除之前保存的数据，请重新填写表单。')
      return
    }
    
    const saved = expiredStorage.getItem('agent-form-step4')
    if (saved) {
      const remainingTime = expiredStorage.getRemainingTime('agent-form-step4')
      console.log(`从过期存储恢复数据，剩余时间: ${remainingTime} 分钟`)
      currentStep.value = 5
    } else {
      console.log('未找到有效的Step4数据或数据已过期')
    }
  } catch (e) {
    console.warn('数据读取失败:', e)
  }
})
</script>

<style scoped>
/* 通用表单容器样式 */
.form-container {
  /*background-color: rgba(51, 51, 51, 0.6);*/
  /*backdrop-filter: blur(15px);*/
  /*border: 1px solid rgba(255, 255, 255, 0.1);*/
  border-radius: 24px;
  /*min-height: 550px; !* 增加高度以适应更底部的输入框 *!
  height: 550px; !* 固定高度，防止内容变化时高度改变 *!*/
  padding: 40px 50px 0px; /* 增加底部padding为输入框留出充足空间 */
  /*width: v-bind(width);*/
  /*max-width: 960px;*/
  /*min-width: 320px;*/
  text-align: center;
  /*box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);*/
  /*margin: 0 auto;*/
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: visible; /* 允许子元素超出容器边界显示 */
  width: 100%;
}

/* 步骤指示器 */
.step-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding: 0 20px;
}

.step-dot {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
}

.step-dot.active {
  background: rgba(76, 175, 80, 0.9);
  border-color: rgba(76, 175, 80, 1);
  color: white;
  box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.2);
}

.step-dot.completed {
  background: rgba(76, 175, 80, 0.8);
  border-color: rgba(76, 175, 80, 1);
  color: white;
}

/* 第0步：欢迎页面样式 */
.step0-welcome {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step0-welcome:hover {
  transform: scale(1.02);
}

.welcome-content {
  text-align: center;
  padding: 40px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.welcome-content:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.welcome-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 20px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.welcome-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 30px;
  line-height: 1.6;
}

.welcome-tap-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  animation: pulse 2s infinite;
}

.tap-icon {
  font-size: 2rem;
  animation: bounce 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* 步骤内容区域 */
.step-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 400px;
}

/* Dialog步骤的特殊样式 */
.step-content.dialog-step {
  min-height: 500px;
}

/* 返回按钮 */
.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  backdrop-filter: blur(10px);
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 1);
}

.back-icon {
  width: 16px;
  height: 16px;
}

/* 第一步箭头按钮 */
.step1-arrow-button {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step1-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step1-arrow-button:active:not(.disabled) {
  transform: translateY(-50%) scale(0.95);
}

.step1-arrow-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
}

.step1-arrow-button.disabled:hover {
  transform: translateY(-50%);
  background: rgba(100, 100, 100, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.step1-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第一步箭头图标（无按钮版） */
.step1-arrow-img {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 10;
}

.step1-arrow-img:not(.disabled):hover {
  transform: translateY(-50%) scale(1.1);
}

.step1-arrow-img.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* 第二步左箭头按钮 */
.step2-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step2-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step2-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

/* 第二步右箭头按钮 */
.step2-right-arrow-button {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step2-right-arrow-button:hover:not(.disabled) {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step2-right-arrow-button:active:not(.disabled) {
  transform: translateY(-50%) scale(0.95);
}

.step2-right-arrow-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
}

.step2-right-arrow-button.disabled:hover {
  transform: translateY(-50%);
  background: rgba(100, 100, 100, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.step2-left-arrow-button .arrow-icon,
.step2-right-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第二步箭头图标（无按钮版） */
.step2-left-arrow-img,
.step2-right-arrow-img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 10;
}
.step2-left-arrow-img { left: 20px; }
.step2-right-arrow-img { right: 20px; }
.step2-right-arrow-img:not(.disabled):hover,
.step2-left-arrow-img:not(.disabled):hover { transform: translateY(-50%) scale(1.1); }
.step2-right-arrow-img.disabled { opacity: 0.4; cursor: not-allowed; }

/* 第三步左箭头按钮 */
.step3-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step3-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step3-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

/* 第三步右箭头按钮 */
.step3-right-arrow-button {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step3-right-arrow-button:hover:not(.disabled) {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step3-right-arrow-button:active:not(.disabled) {
  transform: translateY(-50%) scale(0.95);
}

.step3-right-arrow-button.disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: rgba(100, 100, 100, 0.3);
}

.step3-right-arrow-button.disabled:hover {
  transform: translateY(-50%);
  background: rgba(100, 100, 100, 0.3);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.step3-left-arrow-button .arrow-icon,
.step3-right-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第三步箭头图标（无按钮版） */
.step3-left-arrow-img,
.step3-right-arrow-img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
  z-index: 10;
}
.step3-left-arrow-img { left: 20px; }
.step3-right-arrow-img { right: 20px; }
.step3-right-arrow-img:not(.disabled):hover,
.step3-left-arrow-img:not(.disabled):hover { transform: translateY(-50%) scale(1.1); }
.step3-right-arrow-img.disabled { opacity: 0.4; cursor: not-allowed; }

/* 第四步左箭头按钮 */
.step4-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step4-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step4-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

.step4-left-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 第四步箭头图标（无按钮版） */
.step4-left-arrow-img {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  cursor: pointer;
  transition: transform 0.3s ease;
  z-index: 10;
}
.step4-left-arrow-img:hover { transform: translateY(-50%) scale(1.1); }

/* 第五步（Dialog）左箭头按钮 */
.step5-left-arrow-button {
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.8);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.step5-left-arrow-button:hover {
  background: rgba(76, 175, 80, 1);
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.step5-left-arrow-button:active {
  transform: translateY(-50%) scale(0.95);
}

.step5-left-arrow-button .arrow-icon {
  width: 20px;
  height: 20px;
  color: white;
}

/* 响应式设计 */
@media (max-width: 960px) {
  .form-container {
    width: 70%;
    max-width: 960px;
    min-width: 320px;
    padding: 35px 35px 45px;
    border-radius: 20px;
  }
  
  .step-indicator {
    gap: 15px;
    margin-bottom: 25px;
  }
  
  .step-dot {
    width: 36px;
    height: 36px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .form-container {
    width: 100%;
    max-width: 350px;
    min-width: 280px;
    padding: 25px 25px 35px;
    border-radius: 18px;
  }
  
  .step-indicator {
    gap: 12px;
    margin-bottom: 20px;
  }
  
  .step-dot {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
  
  .back-button {
    top: 15px;
    left: 15px;
    padding: 6px 10px;
    font-size: 13px;
  }
  
  .back-icon {
    width: 14px;
    height: 14px;
  }
  
  .step1-arrow-button {
    width: 45px;
    height: 45px;
    right: 15px;
  }
  
  .step1-arrow-button .arrow-icon {
    width: 18px;
    height: 18px;
  }
}
@media (orientation: portrait) {
    .welcome-content{
        margin-top: 50%;
        transform: scale(2);
    }

}
</style>
